import { outlineGray, primaryColorLight } from '../../config/colors';

export const MODULE_STATUSES = {
  NOT_STARTED: 0,
  STARTED: 1,
  COMPLETED: 2,
};

export const moduleStatuses = {
  NOT_STARTED: {
    color: outlineGray,
    desc: 'No scoring yet',
    value: 0,
  },
  STARTED: {
    color: 'yellow',
    desc: 'Scoring started',
    value: 1,
  },
  COMPLETED: {
    color: 'green',
    desc: 'Scoring completed',
    value: 2,
  },
};

export const inverseModuleStatuses = {
  0: {
    color: outlineGray,
    desc: 'No scoring yet',
    value: 'NOT_STARTED',
  },
  1: {
    color: 'yellow',
    desc: 'Scoring started',
    value: 'STARTED',
  },
  2: {
    color: 'green',
    desc: 'Scoring completed',
    value: 'COMPLETED',
  },
};

export const MODULE_BACKGROUND_COLORS = {
  LIGHT_GREY: '#EAEAEA',
  ORANGE: primaryColorLight,
  GREEN: '#65C090',
  YELLOW: '#E8C95D',
  DARK_GREY: '#B4B4B4',
  PURPLE: '#DCA4C9', // FOR REPLICATION
  PEACH: '#dcb7a4', // FOR BESPOKE
  LIGHT_PEACH: '#dc9870', // FOR REPEATABLE
  MEDIUM_GREY: '#C6C6C6',
};

export const primaryMatch = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  REPLICATION: 'Replication',
};
